import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import useToast from 'hooks/useToast';
import { getCookie } from 'utils/cookies';

/** 세션에 user_type이 있는지 파악, 없을 시 로그인 페이지로 리다이렉션 시키는 hook */
const useCheckSession = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const toast = useToast();

	useEffect(() => {
		//const type = sessionStorage.getItem('uplus_user_type') ?? 'user_type'; // useEffect 내부에서 읽기
		const authToken = getCookie('Authorization');

		if (
			!location.pathname.includes('/login') &&
			!(location.pathname === '/') &&
			!authToken
		) {
			toast('로그인이 필요합니다.', false, true);
			navigate('/login', { replace: true });
		}
	}, [location.pathname]); // 의존성 배열 수정
};

export default useCheckSession;
